/*** Importations **************************************************************************************/

// Polyfills

// import 'mdn-polyfills/NodeList.prototype.forEach';
// import 'mdn-polyfills/Element.prototype.matches';
// import 'mdn-polyfills/Element.prototype.closest';
// import 'mdn-polyfills/CustomEvent';
import 'mdn-polyfills/Node.prototype.prepend';
import 'mdn-polyfills/Node.prototype.append';
import 'mdn-polyfills/Node.prototype.remove';
// import 'mdn-polyfills/Object.assign';
// import 'partials/stepup-stepdown-polyfill';

// import 'classlist-polyfill';
// import 'unfetch/polyfill';
// import 'focus-within-polyfill';
import objectFitImages from 'object-fit-images/dist/ofi.es-modules.js';
import smoothscroll from 'smoothscroll-polyfill';


// Libraries

// import InfiniteScroll from 'infinite-scroll';
// import fullpage from 'fullpage.js';
// import 'owl.carousel';
// import * as basicLightbox from 'basiclightbox/src/scripts/main.js';
// import { CountUp } from 'countup.js';
// import tippy from 'tippy.js/dist/tippy.esm.js';
// import flatpickr from 'flatpickr';
// import fr from "flatpickr/dist/l10n/fr.js";
// import { tns } from 'tiny-slider/src/tiny-slider.module.js';
// import GLightbox from 'glightbox/dist/js/glightbox.js';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock/lib/bodyScrollLock.es6.js';
// import Glide from '@glidejs/glide/dist/glide.esm.js';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.esm.js';
import Swiper, { Navigation, Autoplay, Pagination } from 'swiper/core';


// Scripts Nubee

// import initSliderOwl from 'partials/owl-carousel-nubee.js';
// import initFlatpickr from 'partials/init-flatpickr.js';
import PageMenu from 'partials/page-menu.js';
// import toggleSearchForm from 'partials/toggle-search-form.js';
// import AjaxPopup from 'partials/ajax-popup.js'; // basicLightbox
// import NubeeLightbox from 'partials/nubee-lightbox.js'; // basicLightbox
// import SwipeFinger from 'partials/swipe-finger.js';
// import NumberInput from 'partials/number-input.js';
// import * as nubeeLoading from 'partials/nubee-loading.js';
// import SmoothScroller from 'partials/smooth-scroller.js';
import Tabs from 'partials/tabs.js';
import Accordion from 'partials/accordion.js';
import * as functions from 'partials/functions.js';
import 'partials/scroll-interval.js';
import 'partials/target-blank-security.js';
// import PrettyFileInput from 'partials/pretty-file-input.js';
import placeholderLabelUpdate from 'partials/placeholder-label.js';
import GLightboxNubee from 'partials/glightbox-nubee.js';
// import initSliderTiny from 'partials/tiny-slider-nubee.js';
import googleMapStyles from 'data/google-map-styles.js';
import GoogleMap from 'partials/google-map.js';
import MobileMenu from 'partials/mobile-menu.js';
import imgCheck from 'partials/img-check.js';
// import FormValidation from 'partials/form-validation.js';
import InfiniteScrollSimple from 'partials/infinite-scroll-simple.js';
import LoadingButton from 'partials/loading-button.js';
import FakeSticky from 'partials/fake-sticky.js';
import FilterPosts from 'partials/filter-posts.js';
// import MultiActionForm from 'partials/multi-action-form.js';

// On set toutes les variables globales et évènements qui les modifient ici
import * as globalVarFunctions from 'partials/global-variables.js';

(function() {
	window.acceptedCookies = functions.getCookie('acceptedCookies');

	// Si l'utilisateur a accepter, on va charger GTM
	/*if( window.acceptedCookies !== '' ) {
		let cookiePreferences = JSON.parse( window.acceptedCookies );

		if( cookiePreferences.analytics === true ) {
			functions.injectGTM();
		}
	}*/

	/*** Application des polyfills *********************************************************************/

	(function() {
		objectFitImages();
		smoothscroll.polyfill();

		if( 'function' != typeof window.Event ) {
			window.Event = CustomEvent;
		}
	}) ();


	/*** Variables globales ****************************************************************************/
	// global-variables.js
	// Chaînes traduisibles et autres variables provenant de bones : window.bonesGlobals.i18n.monPlugin.nomDeChaine

	globalVarFunctions.setGlobalVariables();


	/*** Les liens avec ancre qui mènent vers la même page deviennent seulement des ancres *************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linksWithHash = document.querySelectorAll('a[href*="#"]');

		linksWithHash.forEach( function( thisLink ) {
			if( functions.urlsAreSamePage({ urls: [ thisLink.href, window.location.href ] }) ) {
				thisLink.href = thisLink.hash;
			}
		} );
	}) ();


	/*** Défiler doucement les liens ancres ************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js
	// Ajuster la variable globale window.fixedElHeight

	(function() {
		if( window.smoothScroller ) {
			let smoothScrollLinks = document.querySelectorAll('a[href^="#"]:not([href="#"]):not(.no-smooth-scroll):not([target])');

			smoothScrollLinks.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.addEventListener( 'click', function( event ) {
						if( 1 == event.which ) {
							event.preventDefault();

							window.smoothScroller.scrollTo({
								target: thisEl.hash,
								topCorrection: thisEl.dataset.topCorrection != undefined ? thisEl.dataset.topCorrection : false,
								leftCorrection: thisEl.dataset.leftCorrection != undefined ? thisEl.dataset.leftCorrection : false,
							});
						}
					} );
				}
			});
		}
	}) ();


	/*** Ne rien faire au clic sur un lien vide (#) ****************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest('a');
				let theHref = linkClicked ? linkClicked.getAttribute('href') : null;

				if( linkClicked && ( ! theHref || '#' == theHref ) && functions.scriptsOk( linkClicked ) ) {
					event.preventDefault();
				}
			}
		} );
	}) ();


	/*** Images et backgrounds différents selon la taille de l'écran ***********************************/
	// Requiert img-check.js

	(function() {
		if( 'function' == typeof imgCheck ) {
			window.addEventListener( 'resize', imgCheck );
			imgCheck();
		}
	}) ();


	/*** Lazy load des images et backgrounds ***********************************************************/
	// Requiert vanilla-lazyload

	(function() {
		let loadedEvent = new Event( 'lazyloaded' );

		window.siteLazyLoad = new LazyLoad({
			elements_selector: '.lazy',
			class_loading: 'lazy-loading',
			class_loaded: 'lazy-loaded',
			class_error: 'lazy-error',
			// use_native: true,
			callback_loaded: function( element ) {
				element.dispatchEvent( loadedEvent );
			},
		});
	}) ();


	/*** Google Maps ***********************************************************************************/
	// Requiert google-map.js
	// Requiert data/google-map-styles.js (copier-coller votre style là-dedans!)

	(function() {
		let mapParents = document.querySelectorAll('.the-map');

		mapParents.forEach( function( thisParent ) {
			if( functions.scriptsOk( thisParent ) ) {
				new GoogleMap({
					mapParent: thisParent,
					styles: googleMapStyles,
					markerIconUrl: window.bonesGlobals.themeDir + '/assets/images/map-marker.svg'
				});
			}
		} );
	}) ();


	/*** Antispam maison sur les commentaires **********************************************************/
	// À moins d'avoir activé le JS, la validation PHP refusera le commentaire.

	(function() {
		let commentForms = document.querySelectorAll('#commentform');

		commentForms.forEach( function( thisForm ) {
			thisForm.addEventListener( 'submit', function() {
				let legitInput = document.createElement( 'input' );
				legitInput.setAttribute( 'type', 'hidden' );
				legitInput.setAttribute( 'name', 'is_legit' );
				legitInput.value = 1;

				thisForm.appendChild( legitInput );
			} );
		} );
	}) ();


	/*** Validation de formulaire **********************************************************************/
	(function() {
		document.querySelectorAll( '.validate-form' ).forEach( function( thisForm ) {
			if( functions.scriptsOk( thisForm ) ) {
				new FormValidation({
					form: thisForm,
					// debug: true,
				});
			}
		} );
	}) ();


	/*** Placeholder labels - Un placeholder qui se tasse quand on écrit *******************************/
	// Requiert la classe sweet-form sur le formulaire
	// Requiert placeholder-label.js

	(function() {
		document.querySelectorAll('.has-placeholder-label input, .has-placeholder-label textarea').forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				placeholderLabelUpdate( thisEl );

				[ 'load', 'focus', 'blur', 'change', 'input' ].forEach( function( eventName ) {
					thisEl.addEventListener( eventName, placeholderLabelUpdate );
				} );
			}
		} );
	}) ();


	/*** Fait afficher le nom du fichier dans les champs input stylisés ; drag-and-drop ****************/

	(function() {
		let inputs = document.querySelectorAll( '.hidden-file-input' );
		inputs.forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new PrettyFileInput({
					input: thisEl,
				});
			}
		});
	}) ();

	/*** Retour en haut ********************************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js

	(function() {
		let backToTop = document.querySelector('.back-to-top');

		if( backToTop && functions.scriptsOk( backToTop ) ) {
			backToTop.addEventListener( 'click', function() {
				if( 1 == event.which ) {
					window.smoothScroller.scrollTo({ target: document.body });
				}
			} );
		}
	}) ();


	/*** Menu mobile maison ****************************************************************************/

	(function() {
		new MobileMenu({
			menuSel: '.mobile-menu',
			buttonSel: '.mobile-menu-button',
			// debug: true,
			dropdownParentLinkActive: false,

			// Si on agrandit la fenêtre dans ce media query, le menu se ferme automatiquement.
			// closeMediaQuery: '(min-width: 1000px)',

			// viewportMax: { width: 699 },
		});
	}) ();


	/*** Menu de page à hash qui se met à jour avec le scroll ******************************************/
	// Requiert page-menu.js

	(function() {
		window.pageMenus = [];

		window.addEventListener( 'initialscrollend', function() {
			window.pageMenus.push( new PageMenu({
				menuSel: '.page-menu-desktop',
				keepLatest: true,
				debug: false,
			}) );

			// Pas d'update ? Ce menu n'existe pas. On l'enlève de l'array.
			if( 'function' != typeof window.pageMenus[ window.pageMenus.length - 1 ].update ) {
				window.pageMenus.splice( -1, 1 );
			}

			// Version mobile avec select (il faut les dédoubler parce que ça ne marche pas pareil)

			window.pageMenus.push( new PageMenu({
				menuSel: '.page-menu-mobile',
				keepLatest: true,
				type: 'select',
				// pour pas faire l'auto-hash et le Analytics en double avec le menu bureau
				autoHash: false,
				logAnalytics: false,
				debug: false,
			}) );

			// Pas d'update ? Ce menu n'existe pas. On l'enlève de l'array.
			if( 'function' != typeof window.pageMenus[ window.pageMenus.length - 1 ].update ) {
				window.pageMenus.splice( -1, 1 );
			}

			// Update au scroll
			window.addEventListener( 'scrollinterval', function() {
				window.pageMenus.forEach( function( thisMenu ) {
					thisMenu.update();
				} );
			} );
		} );
	}) ();


	/*** Recherche qui s'ouvre/ferme en cliquant sur la loupe ******************************************/
	// Requiert toggle-search-form.js

	/*
	(function() {
		if( 'undefined' !== typeof toggleSearchForm ) {
			document.querySelectorAll('.search-form .search-button').forEach( function( thisEl ) {
				thisEl.addEventListener( 'click', function() {
					if( 1 == event.which ) {
						if( ! thisEl.closest('.search-form').classList.contains('open') ) {
							toggleSearchForm( event );
						} else {
							thisEl.closest('form').submit();
						}
					}
				} );
			} );
		}
	}) ();
	*/

	/*** LoadingButton - bouton pour AJAX avec preloader intégré ***************************************/

	(function() {
		let buttons = document.querySelectorAll('.loading-button');

		buttons.forEach(function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new LoadingButton({
					buttonEl: thisEl,
					debug: false,
				});

				// Le bouton est maintenant initialisé. On peut l'activer avec les méthodes :
				// buttonInstance.loadingStart() | buttonInstance.loadingEnd()
				// Fonctionnent aussi :
				// thisEl._loadingButton.loadingStart() | thisEl._loadingButton.loadingEnd()
			}
		} );
	}) ();

	/*** InfiniteScrollSimple - Version maison plus légère *********************************************/
	// Requiert infinite-scroll-simple.js
	// Requiert regenerator-runtime (Babel veut ça pour les fonctions async)
	// Voir le début du fichier pour des events sur lesquels vous hooker

	window.addEventListener('load', function(){
		let infiniteContainers = document.querySelectorAll('.iss-container');

		infiniteContainers.forEach(function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {

				new InfiniteScrollSimple({
					container: thisEl,
					useInner: true,
					animate: true,
					hideButton: thisEl.classList.contains('post-list-program') ? true : false,
					debug: false,
					scrollThreshold: 150,
				});
			}
		} );

	});

	/*** Infinite Scroll - Charger les prochains articles automatiquement ******************************/
	// Requiert infinite-scroll.pkgd.min.js

	/*(function() {
		let infiniteContainers = document.querySelectorAll('.iss-container');

		infiniteContainers.forEach(function( thisEl ) {
			if( thisEl.querySelector('.wrap-iss-button .iss-button') ) {
				let infiniteInstance = new InfiniteScroll( '.iss-container-inner', {
						path: '.wrap-iss-button .iss-button',
						append: '.iss-item',
						prefill: false,
						history: false,
						// outlayer: outlayer,
						hideNav: '.wrap-iss-button',
						// status: '.infinite-scroll-status',
						status: false,
						debug: true,
					});

				infiniteInstance.on( 'append', function( event, response, path, items ) {
					// thisEl.parentNode.querySelector('.infinite-scroll-status').style.display = 'none';
					imgCheck();
					window.siteLazyLoad.update();
				} );
			}
		});
	}) ();*/



	/*** Dropdown de médias sociaux ********************************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let buttonClicked = event.target.closest('.more-networks-button');
				let theContainer;
				let theDropdown;

				if( buttonClicked && functions.scriptsOk( buttonClicked ) ) {
					theContainer = buttonClicked.closest( '.more-networks' );
					theDropdown = theContainer.querySelector( '.more-networks-dropdown' );

					if( ! theContainer.classList.contains('animating') ) {
						theContainer.classList.add( 'animating' );

						if( ! theContainer.classList.contains( 'open' ) ) {
							theContainer.classList.add( 'open' );

							theDropdown.addEventListener( 'transitionend', function fadeInOver() {
								theContainer.classList.remove( 'animating' );
								theDropdown.removeEventListener( 'transitionend', fadeInOver );
							} );

						} else {
							theContainer.classList.remove( 'open' );

							theDropdown.addEventListener( 'transitionend', function fadeOutOver() {
								theContainer.classList.remove( 'animating' );
								theDropdown.removeEventListener( 'transitionend', fadeOutOver );
							} );
						}
					}
				}
			}
		} );
	}) ();


	/*** Sliders Swiper ********************************************************************************/
	// Requiert Swiper

	(function() {
		Swiper.use( [ Navigation, Autoplay ] );

		let latest_news_slider = new Swiper( '.page-block-latest-news .swiper', {
			speed: 400,
			spaceBetween: 15,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: false,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: false,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				500: { slidesPerView: 2, },
				1000: { slidesPerView: 3, },
				1900: { slidesPerView: 4, },
  			},
		});

		let media_slider = new Swiper( '.page-block-media-slider .swiper', {
			speed: 400,
			spaceBetween: 15,
			slidesPerView: 2,
			direction: 'horizontal',
			loop: false,
			preventInteractionOnTransition: true,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: false,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				700: { slidesPerView: 3, },
				1000: { slidesPerView: 4, },
				1300: { slidesPerView: 5, },
				1600: { slidesPerView: 6, },
  			},
		});
	}) ();

	/*** Sliders Glide *********************************************************************************/
	// Requiert Glide (@glidejs/glide)
	// Ce slider n'a pas de fonction tout-en-un disponible.

	// large-slider-gallery
	/*(function() {
		let linkSliders = document.querySelectorAll('.page-block-large-slider-gallery .glide-slider');

		linkSliders.forEach( function( sliderEl ) {
			if( functions.scriptsOk( sliderEl ) ) {
				let sliderOptions = {
					type: 'slider',
					perView: 1,
					gap: 15,
					bound: true,
					rewind: true,
				};

				let sliderInstance = new Glide( sliderEl, sliderOptions );

				sliderInstance.on( 'move', function() {
					window.siteLazyLoad.update();
					sliderEl.classList.add( 'slider-animating' );
				} );

				sliderInstance.on( 'move.after', function() {
					window.siteLazyLoad.update();
					sliderEl.classList.remove( 'slider-animating' );
				} );

				sliderInstance.mount();
			}
		} );
	}) ();*/

	// testimonials-slider
	/*(function() {
		let linkSliders = document.querySelectorAll('.page-block-testimonials-slider .glide-slider');

		linkSliders.forEach( function( sliderEl ) {
			if( functions.scriptsOk( sliderEl ) ) {
				let sliderOptions = {
					type: 'carousel',
					perView: 1,
					gap: 50,
					bound: false,
					rewind: true,
					autoplay: 10000,
					hoverpause: true,
				};

				let sliderInstance = new Glide( sliderEl, sliderOptions );

				sliderInstance.on( 'move', function() {
					window.siteLazyLoad.update();
					sliderEl.classList.add( 'slider-animating' );
				} );

				sliderInstance.on( 'move.after', function() {
					window.siteLazyLoad.update();
					sliderEl.classList.remove( 'slider-animating' );
				} );

				sliderInstance.mount();
			}
		} );
	}) ();*/


	/*** Sliders Tiny Slider ***************************************************************************/
	// Requiert tns (tiny-slider)
	// Requiert initSliderTiny (tiny-slider-nubee.js)

	/*(function() {
		document.querySelectorAll('.tiny-slider').forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				initSliderTiny( thisEl );
			}
		} );
	}) ();*/


	/*** Empêcher la taille d'un élément de se réajuster une fois le chargement terminé ****************/

	(function() {
		let lockedHeightEls = document.querySelectorAll('.lock-height-on-load');

		window.addEventListener( 'load', function() {
			lockedHeightEls.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.style.height = thisEl.offsetHeight + 'px';
					thisEl.style.minHeight = 0;
					thisEl.style.maxHeight = 'none';
				}
			} );
		} );
	}) ();


	/*** Select qui redirigent quand on choisit une option *********************************************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linkSelects = document.querySelectorAll('.link-select');

		linkSelects.forEach( function( thisSelect ) {
			if( functions.scriptsOk( thisSelect ) ) {
				[ 'change', 'keypress' ].forEach( function( eventName ) {
					thisSelect.addEventListener( eventName, function() {
						let selectedOption = thisSelect.options[ thisSelect.selectedIndex ];
						let targetUrl = selectedOption.dataset.url;

						if( targetUrl ) {
							if( /^#.+/.test( targetUrl ) ) {
								window.smoothScroller.scrollTo({ target: targetUrl });
							} else if( ! functions.urlsAreSamePage({ urls: targetUrl }) ) {
								window.location.href = targetUrl;
							}
						}
					} );
				} );
			}
		} );
	}) ();


	/*** Activation du doigt indicateur de scroll sur les blocs de statistiques appropriés *************/
	// Requiert swipe-finger.js

	/*
	(function() {
		if( 'undefined' !== typeof SwipeFinger ) {
			let fingerWrappers = document.querySelectorAll('.swipe-finger-wrapper');
			fingerWrappers.forEach( function( thisWrapper ) {
				if( functions.scriptsOk( thisWrapper ) ) {
					let swipeFinger = new SwipeFinger({
						wrapper: thisWrapper,
						debug: false,
					});
				}
			} );
		}
	}) ();
	*/


	/*** Défile doucement au chargement d'une URL avec ancre *******************************************/
	// Évènement "hashblocked" pour dire que le jump par défaut vient d'être bloqué
	// Évènement "initialscrollstart" pour dire qu'on s'apprête à faire le scroll
	// Évènement "initialscrollend" pour dire que la page est chargée ET l'ancre active est scrollée
	// S'il n'y a pas d'ancre (#) active, l'évènement est lancé dès le chargement.
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js

	(function() {
		let origHash = window.location.hash;
		let hashBlockedEvent = new Event( 'hashblocked' );
		let scrollStartEvent = new Event( 'initialscrollstart' );
		let scrollEndEvent = new Event( 'initialscrollend' );

		if( origHash ) {
			let targetEl = document.querySelector( origHash );

			if( targetEl ) {
				window.addEventListener( 'hashblocked', function() {
					window.addEventListener( 'smoothscrollend', function initialScrollEnd() {
						window.dispatchEvent( scrollEndEvent );
						window.removeEventListener( 'smoothscrollend', initialScrollEnd );
					} );

					window.dispatchEvent( scrollStartEvent );

					window.smoothScroller.scrollTo({
						target: origHash,
						historyState: history.state,
						historyAction: 'replace',
						// debug: true,
					});
				} );


				// Blocage du jump du navigateur par défaut
				setTimeout( function() {
					functions.changeHashWithoutScrolling( null, history.state, 'replace' );
					window.scrollTo( 0, 0 );
					window.dispatchEvent( hashBlockedEvent );
				}, 1 );
			} else {
				window.dispatchEvent( scrollEndEvent );
			}
		} else {
			window.dispatchEvent( scrollEndEvent );
		}
	}) ();


	/*** Donner la même hauteur à un groupe d'éléments *************************************************/

	(function() {
		window.addEventListener( 'load', function() {
			let sameHeightGroups = document.querySelectorAll('.same-height-group');

			sameHeightGroups.forEach( function( thisGroup ) {
				if( functions.scriptsOk( thisGroup ) ) {
					let minWidth = thisGroup.dataset.sameHeightMinWidth || 0;
					let sameHeightEls = thisGroup.querySelectorAll('.same-height');
					let highestHeight = 0;

					if( window.vWidth >= minWidth ) {
						sameHeightEls.forEach( function( thisEl ) {
							highestHeight = Math.max( thisEl.clientHeight, highestHeight );
						} );

						sameHeightEls.forEach( function( thisEl ) {
							thisEl.style.minHeight = highestHeight + 'px';
						} );
					}
				}
			} );
		} );
	}) ();


	/*** smoothFadeIn - effet d'apparition lorsque dans le viewport ************************************/
	// Requiert functions.smoothFadeIn
	// Options dans general-styles.scss

	(function() {
		let fadeInItems = document.querySelectorAll('.smooth-fade-in');

		fadeInItems.forEach( function( thisEl ) {
			functions.smoothFadeIn( thisEl );

			window.addEventListener( 'scrollinterval', function() {
				functions.smoothFadeIn( thisEl );
			} );
		} );
	}) ();



	/*** Onglets ***************************************************************************************/
	// Requiert tabs.js

	
	(function() {
		let tabsContainers = document.querySelectorAll('.tabs-block');

		tabsContainers.forEach( function( thisEl ) {
			new Tabs({
				container: thisEl,
				debug: false,
			});
		} );
	}) ();



	/*** Accordion *************************************************************************************/
	// Requiert accordion.js

	
	(function() {
		let accordionsEl = document.querySelectorAll('.accordion .accordion-item');

		accordionsEl.forEach( function( el ) {
			new Accordion( el );
		} );
	}) ();
	



	/*** Tooltips tippy ********************************************************************************/
	// Requiert tippy.js
	/*
	(function() {
		tippy( '[data-tippy-content]', {
			theme: 'light',
			flipBehavior: [ 'bottom', 'left' ],
		} );
	}) ();
	*/


	/*** Lightbox et popups avec GLightbox *************************************************************/
	// Requiert GLightbox (glightbox)
	// Requiert glightbox-nubee.js

	(function() {
		// Éléments seuls.
		let lightboxEls = document.querySelectorAll('.lightbox');
		lightboxEls.forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new GLightboxNubee({
					links: thisEl,
					// debug: true,
				});
			}
		} );

		// Galeries. (Attention de donner une classe différente à chaque galerie de la page.)
		// Utilisez data-lightbox-element-class="ma-classe" sur .lightbox-gallery pour l'identifier.
		let lightboxGals = document.querySelectorAll('.lightbox-gallery');
		lightboxGals.forEach( function( thisGal ) {
			if( functions.scriptsOk( thisGal ) ) {
				new GLightboxNubee({
					galleryParent: thisGal,
					elementSel: '.' + thisGal.dataset.galleryElClass,
					debug: true,
				});
			}
		} );

		// On peut maintenant accéder aux instances à partir des liens ou du parent de la galerie :
		// <un lien lightbox ou un div galerie>._GLightboxNubee
		// <un lien lightbox ou un div galerie>._GLightbox
	}) ();


	/*** Boutons +/- des input type number *************************************************************/
	// Requiert NumberInput (number-input.js)

	/*
	(function() {
		let inputs = document.querySelectorAll('.input-number');

		inputs.forEach( function( thisInput ) {
			let inputInstance = new NumberInput({
				input: thisInput,
			});
		} );
	}) ();
	*/


	/*** Datepickers avec flatpickr ********************************************************************/
	// Requiert initFlatpickr (init-flatpickr.js)
	// Requiert flatpickr
	/*
	(function() {
		let dateFields = document.querySelectorAll('.input-date');

		dateFields.forEach( function( thisField ) {
			initFlatpickr( thisField );
		} );
	}) ();



	/*** fake-sticky ***********************************************************************************/
	// Requiert fake-sticky.js
	// Pour quand le CSS display: sticky; marche pas bien.

	(function() {
		let fakeStickies = document.querySelectorAll('.fake-sticky');

		fakeStickies.forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				let fakeStickyArgs = {
					element: thisEl,
					// debug: true,
					minWidth: thisEl.dataset.fakeStickyMinWidth || null,
					maxWidth: thisEl.dataset.fakeStickyMaxWidth || null,
					minHeight: thisEl.dataset.fakeStickyMinHeight || null,
					maxHeight: thisEl.dataset.fakeStickyMaxHeight || null,

					// mediaQueries à [] = meilleure performance ; aucun ajustement au resize
					// Définir des mediaQueries = bonne performance ; ajustement aux mediaQueries seulement
					// mediaQueries à null = ajustement au pixel près
					mediaQueries: [
						'(min-height: 600px)', // height!
					],
				};

				fakeStickyArgs.minHeight = thisEl.dataset.fakeStickyMinHeight || null;

				new FakeSticky( fakeStickyArgs );
			}
		} );
	}) ();


	/*** Formulaire de recherche - changement de l'URL cible quand on choisit une option au select *****/
	// Requiert multi-action-form.js

	(function() {
		let multiActionForms = document.querySelectorAll('.multi-action-form');

		multiActionForms.forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new MultiActionForm({
					form: thisEl,
					sourceElSel: '.multi-action-form-url',
					debug: true,
				});
			}
		} );
	}) ();

	/*** Appliquer les filtres dans les archives lorsque nécessaire ************************************/

	(function() {

		document.querySelectorAll('.filters-form').forEach(function( thisForm ) {
			if( functions.scriptsOk( thisForm ) ) {
				new FilterPosts({
					form: thisForm,
					container: thisForm.closest('.sidebar-filters').nextElementSibling,
					useInner: true,
					animate: true,
					debug: false,
				});
			}
		} );


	}) ();

	/*** Permettre d'afficher masquer les filtres sur mobile *******************************************/

	(function() {

		document.querySelectorAll('.show-filters').forEach(function( thisEl ) {
			thisEl.addEventListener( 'click', function( event ) {
				event.preventDefault();

				this.nextElementSibling.classList.add( 'visible' );

				disableBodyScroll( this.nextElementSibling );
			});
		});

		document.querySelectorAll('.close-filters').forEach(function( thisEl ) {
			thisEl.addEventListener( 'click', function( event ) {
				event.preventDefault();

				this.closest('.checkboxes-filters').classList.remove( 'visible' );

				enableBodyScroll( this.closest('.checkboxes-filters') );
			});
		});

	}) ();

	/*** Ajouter un padding au bloc précédent un bloc avec un margin négatif ***************************/
	(function() {

		function adaptPaddingNegativeMargin() {
			// Pour les block simple-text avec contenu centré
			document.querySelectorAll('.page-block-has-bg-color + .block-position-negative-margin').forEach(function( thisEl ) {
				
				let previousBlock = thisEl.previousElementSibling;
				let nextBlock = thisEl.nextElementSibling;

				let defaultPadding = window.window.vWidth < 800 ? 0 : 0;
				
				// if( window.window.vWidth >= 800 ) {
					let elementHeight = thisEl.offsetHeight,
						paddingToAdd = Math.ceil( elementHeight / 2 );

					// On s'assure que l'élément existe et qu'on peut travailler avec
					if( previousBlock !== 'undefined' && previousBlock.nodeType === Node.ELEMENT_NODE ) {
						
						previousBlock.style.paddingBottom = paddingToAdd + 'px';
					}

					if( nextBlock !== null && nextBlock.classList.contains('page-block-has-bg-color') ) {
						let marginCorrected = elementHeight +defaultPadding;

						thisEl.style.marginBottom = '-' + marginCorrected + 'px';
						nextBlock.style.paddingTop = paddingToAdd + 'px';
						nextBlock.classList.add('padding-added');
					} else {
						let marginCorrected = paddingToAdd + defaultPadding;

						thisEl.style.marginBottom = '-' + marginCorrected + 'px';
					}

				// } else {
					// previousBlock.style.paddingBottom = null;
					// thisEl.style.marginBottom = null;
					// nextBlock.style.paddingTop = null;
				// }

			});

			// Pour le block library
			document.querySelectorAll('.page-block-library-search').forEach(function( thisEl ) {
				let thisElHeight,
					nextEl = thisEl.nextElementSibling,
					nextElInner = nextEl.querySelector('.page-block-inner'),
					// nextElInitialPadding = parseInt( window.getComputedStyle( nextElInner, null ).getPropertyValue('padding-top') );
					nextElInitialPadding = 90;

				if( nextEl !== undefined && thisEl.nextElementSibling.classList.contains( 'page-block-has-bg-color' ) ) {
					thisElHeight = Math.ceil( thisEl.offsetHeight / 2 );

					thisEl.classList.add( 'page-block-negative-margin' );
					thisEl.style.marginBottom = '-' + thisElHeight + 'px';

					// Ajouter un padding de la moitié de la hauteur du block précédent + sont padding actuel
					console.log( nextElInitialPadding + thisElHeight );
					nextElInner.style.paddingTop = ( nextElInitialPadding + thisElHeight ) + 'px';
				}
			});
		}

		window.addEventListener( 'resize', adaptPaddingNegativeMargin );
		adaptPaddingNegativeMargin();
	
	}) ();

	/*** Fermer le message *****************************************************************************/
	/*(function() {
		document.querySelectorAll( '.close-announcement' ).forEach( function( thisButton ) {
			if( functions.scriptsOk( thisButton ) ) {
				thisButton.addEventListener( 'click', function() {
					if( 1 == event.which ) {
						thisButton.closest( '.announcements' ).classList.toggle('is-hidden');
					}
				});
			}
		} );
	}) ();*/

	/*** Rediriger les utilisateur lors du changements de Tu es intéressé par *************************/
	(function() {
		document.querySelectorAll( '.search-by-interest' ).forEach( function( thisSelect ) {
			thisSelect.addEventListener( 'change', function(){
				if( thisSelect.value !== undefined || thisSelect.value !== null ) {
					window.location = thisSelect.value;
				}
			});
		});
	}) ();

	/*** Mettre les label Gravity Forms en mode focus quand ils ont une valeur *************************/
	(function() {
		document.querySelectorAll( '.gfield' ).forEach( function( thisFormRow ) {
			thisFormRow.querySelectorAll( 'input, textarea, select' ).forEach( function( thisField ) {
				if( thisField.value !== '' ) { thisFormRow.classList.add( 'has-value' ); }

				thisField.addEventListener( 'change', function(){
					if( thisField.value !== '' ) { 
						thisFormRow.classList.add( 'has-value' );
					} else {
						thisFormRow.classList.remove( 'has-value' );
					}
				} );
			} );
		} );
	}) ();

	/*** Désactiver le bouton après un click dans les formulaires Gravity Forms *************************/
	(function() {
		document.querySelectorAll( '.gform_button' ).forEach( function( thisButton ) {
			thisButton.addEventListener( 'click', function() {
				thisButton.disabled = true;
				thisButton.closest('form').submit();
			} );
		} );
	}) ();

	/*** Soumettre le formulaire avec les filtres select *************************/
	(function() {
		document.querySelectorAll( '.post-list-filters-select .select' ).forEach( function( theSelect ) {
			let theForm = theSelect.closest('.post-list-filters-select-form');

			theSelect.addEventListener( 'change', function(){
				theForm.submit();
			} );
		});
	}) ();

	/*** On va ouvrir les accordions par défaut lors de l'impression *************************/
	(function() {

		window.onbeforeprint = function( ){
			document.querySelectorAll( 'details' ).forEach( function( thisEl ) {
				thisEl.setAttribute("open", "");
			});
		};
		/*window.matchMedia('print').addListener( function( matchMedia ) {
			if( matchMedia.matches ) {
				document.querySelectorAll( 'details' ).forEach( function( thisEl ) {
					thisEl.setAttribute("open", "");
				});
			}
		});*/

	}) ();

	/*** Gestion des préférence de cookies ***************************************/

	(function() {
		let cookieConsent = document.getElementById('cookie-consent'),
			cookieConsentBar = cookieConsent.querySelector('.bar'),
			cookieConsentDetails = cookieConsent.querySelector('.details'),

			cookieBtnCustomize = cookieConsentBar.querySelector('#cookies-customize'),
			cookieBtnCustomizeState = cookieBtnCustomize.querySelector('.symbol'),
			cookieBtnAccept = cookieConsentBar.querySelector('#cookies-accept'),
			cookieBtnReject = cookieConsentBar.querySelector('#cookies-reject'),
			cookieBtnSave = document.getElementById('cookies-save'),

			cookieSwitchNecessary = cookieConsentDetails.querySelector('#toggleSwitchNecessary'),
			cookieSwitchFunctional = cookieConsentDetails.querySelector('#toggleSwitchFunctional'),
			cookieSwitchAnalytics = cookieConsentDetails.querySelector('#toggleSwitchAnalytics'),
			cookieSwitchAdvertissement = cookieConsentDetails.querySelector('#toggleSwitchAdvertissement'),

			cookiePreferences = {},

			gtag_consent = {},

			expiryDate;

		expiryDate = new Date();
		expiryDate.setMonth( ( expiryDate.getMonth() + 1 ) % 12 );

		// Si on a pas encore choisi ses préférences de cookies, on affiche la bance
		if( window.acceptedCookies === '' ) {
			cookieConsent.classList.remove('hidden');
			cookieConsent.classList.add('closed');

			let translateValue = cookieConsent.clientHeight - cookieConsentBar.clientHeight;

			cookieConsent.style.transform = 'translateY( ' + translateValue + 'px )';

			setTimeout( function() {
				if( translateValue != ( cookieConsent.clientHeight - cookieConsentBar.clientHeight ) ) {
					cookieConsent.style.transform = 'translateY( ' + ( cookieConsent.clientHeight - cookieConsentBar.clientHeight ) + 'px )';
				}
			}, 500 )

		// Sinon, on va mettre les switch aux bonnes valeurs au cas où l'utilisateur réouvrirais la boite
		} else {
			cookiePreferences = JSON.parse( window.acceptedCookies );

			if( cookieSwitchFunctional !== null ) {
				cookieSwitchFunctional.checked = cookiePreferences.functional;
			}

			if( cookieSwitchAnalytics !== null ) {
				cookieSwitchAnalytics.checked = cookiePreferences.analytics;

				gtag_consent.analytics_storage = cookieSwitchAnalytics.checked ? 'granted' : 'denied';
			}

			if( cookieSwitchAdvertissement !== null ) {
				cookieSwitchAdvertissement.checked = cookiePreferences.advertissement;

				gtag_consent.ad_storage = cookieSwitchAdvertissement.checked ? 'granted' : 'denied';

          		// Gestion du cookie _fbp
				if (cookieSwitchAdvertissement.checked) {
					document.cookie = "_fbp=1; expires=" + expiryDate.toUTCString() + "; path=/";
				} else {
					document.cookie = "_fbp=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
				}
			}

			if( bonesGlobals.gsk_analytics_id !== '' ) { gtag( 'consent', 'update', gtag_consent ); }
		}

		// Si on resize on ajuste le translate pour voir juste la bande par défaut
		window.addEventListener( 'resize', function() {
			if( window.acceptedCookies === '' && cookieConsent.classList.contains('closed') ) {
				cookieConsent.style.transform = 'translateY( ' + ( cookieConsent.clientHeight - cookieConsentBar.clientHeight ) + 'px )';
			}
		});

		// Réouvrir la bande si on clique sur le lien du footer
		if( document.getElementById('open-cookie-bar') ) {
			document.getElementById('open-cookie-bar').addEventListener('click', function(e){
				e.preventDefault();

				cookieConsent.classList.remove('hidden');
				cookieConsent.classList.add('closed');

				cookieConsent.style.transform = 'translateY( ' + ( cookieConsent.clientHeight - cookieConsentBar.clientHeight ) + 'px )';
				cookieBtnCustomizeState.textContent = '+';
			});
		}

		// Ouvrir les préférences personnalisé
		cookieBtnCustomize.addEventListener('click', function(e){
			e.preventDefault();

			if( cookieConsent.classList.contains('closed') ) {
				cookieConsent.style.transform = 'translateY( 0px )';
				cookieBtnCustomizeState.textContent = '-';
			} else {
				cookieConsent.style.transform = 'translateY( ' + ( cookieConsent.clientHeight - cookieConsentBar.clientHeight ) + 'px )';
				cookieBtnCustomizeState.textContent = '+';
			}

			cookieConsent.classList.toggle('closed');
		});

		// On va enregistrer les préférences de l'utilisateur
		cookieBtnSave.addEventListener('click', function(e){
			e.preventDefault();

			let needRefresh = false;

			if( cookieSwitchFunctional !== null ) {
				cookiePreferences.functional = cookieSwitchFunctional.checked;

				needRefresh = true;
			}

			if( cookieSwitchAnalytics !== null ) {
				cookiePreferences.analytics = cookieSwitchAnalytics.checked;
				needRefresh = true;

				gtag_consent.analytics_storage = cookieSwitchAnalytics.checked ? 'granted' : 'denied';
			}

			if( cookieSwitchAdvertissement !== null ) {
				cookiePreferences.advertissement = cookieSwitchAdvertissement.checked;
				needRefresh = true;

				gtag_consent.ad_storage = cookieSwitchAdvertissement.checked ? 'granted' : 'denied';
				document.cookie = "_fbp=1; expires=" + expiryDate.toUTCString() + "; path=/";
			}

			document.cookie = "acceptedCookies=" + JSON.stringify( cookiePreferences ) + "; expires=" + expiryDate + "; path=/";

			cookieConsent.classList.remove('closed');
			cookieConsent.classList.add('hidden');


			if( bonesGlobals.gsk_analytics_id !== '' ) { gtag( 'consent', 'update', gtag_consent ); }
			// if( needRefresh ) { location.reload( true ); }
		});

		// On accepte tous les cookies
		cookieBtnAccept.addEventListener('click', function(e){
			e.preventDefault();

			let needRefresh = false;

			if( cookieSwitchFunctional !== null ) {
				cookiePreferences.functional = true;
				needRefresh = true;
			}

			if( cookieSwitchAnalytics !== null ) {
				cookiePreferences.analytics = true;
				needRefresh = true;

				gtag_consent.analytics_storage = 'granted';
			}

			if( cookieSwitchAdvertissement !== null ) {
				cookiePreferences.advertissement = true;
				needRefresh = true;

				gtag_consent.ad_storage = 'granted';
			}

			document.cookie = "acceptedCookies=" + JSON.stringify( cookiePreferences ) + "; expires=" + expiryDate + "; path=/";

			cookieConsent.classList.remove('closed');
			cookieConsent.classList.add('hidden');

			if( bonesGlobals.gsk_analytics_id !== '' ) { gtag( 'consent', 'update', gtag_consent ); }
			// if( needRefresh ) { location.reload( true ); }
		});

		// On refuse tous les cookies
		cookieBtnReject.addEventListener('click', function(e){
			e.preventDefault();

			let needRefresh = false;

			if( cookieSwitchFunctional !== null ) {
				cookiePreferences.functional = false;
				needRefresh = true;
			}

			if( cookieSwitchAnalytics !== null ) {
				cookiePreferences.analytics = false;
				needRefresh = true;

				gtag_consent.analytics_storage = 'denied';
			}

			if( cookieSwitchAdvertissement !== null ) {
				cookiePreferences.advertissement = false;
				needRefresh = true;

				gtag_consent.ad_storage = 'denied';
				document.cookie = "_fbp=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
			}

			document.cookie = "acceptedCookies=" + JSON.stringify( cookiePreferences ) + "; expires=" + expiryDate + "; path=/";

			cookieConsent.classList.remove('closed');
			cookieConsent.classList.add('hidden');

			if( bonesGlobals.gsk_analytics_id !== '' ) { gtag( 'consent', 'update', gtag_consent ); }
			// if( needRefresh ) { location.reload( true ); }
		});
	}) ();

	/*** Aller voir s'il y a des annonces a afficher *******************************/
	( function() {

		setTimeout( function( ) {

			let formData = new FormData();

			formData.append( 'action', 'announcement' );
			formData.append( 'post_id', bonesGlobals.current_post.post_id );
			formData.append( 'post_type', bonesGlobals.current_post.post_type );

			// console.log(atnGlobals.ajaxUrl);

			fetch( bonesGlobals.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				/*headers: {
					'Content-Type': 'application/json'
					// 'Content-Type': 'application/x-www-form-urlencoded'
				},*/
				// body: JSON.stringify( formData )
				body: formData
			})
			.then( function( response ) {
				// The API call was successful!
				return response.text();
			}).then( function( html ) {

				if( html ) {

					// Convert the HTML string into a document object
					let parser = new DOMParser(),
						doc = parser.parseFromString( html, 'text/html' ),
						announcements = document.getElementById('announcements');

					// Vider le contenu du wrapper d'annonce au cas
					var announcementsChildren = Array.prototype.slice.call( announcements.childNodes );

					// Remove each child node
					announcementsChildren.forEach( function ( child ) {
						announcements.removeChild( child );
					} );

					announcements.innerHTML = html;

					let nbAnnouncements = doc.querySelectorAll('.announcement').length;

					if( nbAnnouncements > 0 ) {
						announcements.classList.remove('is-hidden');
					}

					// Si on a plus qu'une annonce, on va transformer la bande en swiper
					console.log( 'nbAnnouncements : ' + nbAnnouncements );

					if( nbAnnouncements > 1 ) {
						announcements.classList.add('swiper');

						let activeIndexEl = announcements.querySelector( '.swiper-count .current' ),
							totalSlidesEl = announcements.querySelector( '.swiper-count .total' );

						Swiper.use( [ Pagination, Autoplay ] );

						new Swiper( announcements, {
							speed: 400,
							spaceBetween: 0,
							slidesPerView: 1,
							direction: 'horizontal',
							loop: false,
							touchEventsTarget: 'wrapper',
							preventInteractionOnTransition: true,
							effect: 'slide',
							preloadImages: true,
							shortSwipes: true,
							autoHeight: false,
							autoplay: {
								delay: 5000,
							},
							lazy: {
								loadPrevNext: true,
							},
							pagination: {
								el: ".swiper-pagination",
								clickable: true,
								type: "bullets",
							},
				  			// modules: [ Pagination, Autoplay ],
				  			on: {
				  				init: function( sw ) {
				  					activeIndexEl.textContent = sw.activeIndex +  1;
				  					totalSlidesEl.textContent = sw.slides.length;
				  				},
				  				slideChangeTransitionEnd: function( sw ) {
				  					activeIndexEl.textContent = sw.activeIndex +  1;
				  				}
				  			}
						});

					}

					document.getElementById('close-announcement').addEventListener( 'click', function (event) {
						event.preventDefault();

						let currentDate = new Date();

						let expirationDate = new Date(
							currentDate.getFullYear(),
							currentDate.getMonth(),
							currentDate.getDate() + 1,
							0, 0, 0
						);

						announcements.querySelectorAll( '.announcement' ).forEach( function( thisAnnouncement ) {
							document.cookie = thisAnnouncement.id + "=is-hidden; expires=" + expirationDate.toGMTString + "; path=/";
						});

						announcements.classList.add( 'is-hidden' );


					}, false );
				}


			}).catch( function( error ) {
				// There was an error
				console.warn('Something went wrong.', error);
			});

		}, 50 );

	} ) ();



	/*** Cookie de jusqu'au lendemain minuit pour les annonces *******************************/

	function showAnnouncements() {

		let currentDate = new Date();

		// Demain minuit
		let expirationDate = new Date(
				currentDate.getFullYear(),
				currentDate.getMonth(),
				currentDate.getDate() + 1,
				0, 0, 0
			);

		let announcementsEl = document.getElementById('announcements');

		if( announcementsEl ) {
			let	announcements = announcementsEl.querySelectorAll( '.announcement' ),
				announcements_count = announcements.length;

			announcements.forEach( function( thisAnnouncement ) {
				let thisAnnouncementCookie = functions.getCookie( thisAnnouncement.id );

				if( thisAnnouncementCookie !== 'is-hidden' ) {
					thisAnnouncement.classList.remove( 'is-hidden' );

					let thisAnnouncementCookieObj = document.querySelector( '#' + thisAnnouncement.id + ' .close-announcement' );

					if( thisAnnouncementCookieObj ) {
						thisAnnouncementCookieObj.addEventListener( 'click', function (event) {
							event.preventDefault();

							document.cookie = thisAnnouncement.id + "=is-hidden; expires=" + expirationDate.toGMTString + "; path=/";
							thisAnnouncement.classList.add( 'is-hidden' );

							if( announcementsEl.querySelectorAll( '.announcement.is-hidden' ).length === announcements_count ) {
								announcementsEl.classList.toggle('is-hidden');
							} else if( announcementsEl.querySelectorAll( '.announcement:not(.is-hidden)' ).length === 1 ) {
								announcementsEl.classList.remove('more-than-one');
							}
						}, false );
					}
				}
			});

			if( announcementsEl.querySelectorAll( '.announcement.is-hidden' ).length !== announcements_count ) {
				announcementsEl.classList.remove('is-hidden');
			}
		}
	}


}) ();